import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Flex, FormLabel, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import InputLabel from '../../../../../../components/form/InputLabel';
import { JobProfilePage } from '../../../../../../constants/duskIds';
import { inAppText } from '../../../../../../constants/inAppText';
import { Statuses } from '../../../../../../constants/statuses';
import { getJobStats, selectJobProfile } from '../../../../../../redux/modules/jobs';
import colors from '../../../../../../styles/theme/foundation/colors';
import ProgressCircle from '../../../../../JobsPage/components/ProgressCircle';

const StatsFormLabel = ({ label, textAlign = 'center' }) => (
  <FormLabel
    color="greyScale.500"
    fontSize="13px"
    mb="8px"
    mr={0}
    textAlign={textAlign}
    w="100%"
  >
    {label}
  </FormLabel>
);

const JobStats = () => {
  const dispatch = useDispatch();
  const jobProfile = useSelector(selectJobProfile);

  useEffect(() => {
    dispatch(getJobStats(jobProfile.jobId));
  }, [dispatch, jobProfile.jobId]);

  const isArchived = jobProfile?.status === Statuses.Archived;

  return (
    <Flex justify="flex-start" mb="10px" width="312px">
      <Box w="50%">
        <InputLabel labelName="Active Insureds" toolTip={inAppText.tooltips.projectDetails.projectInformation.activeInsureds} />
        <Text
          color={isArchived ? colors.greyScale['800'] : colors.primaryScale['600']}
          data-dusk-value={jobProfile?.stats?.activeInsureds}
          dusk={JobProfilePage.activeRecords}
          fontSize="lg"
          fontWeight="medium"
          lineHeight="41px"
          textAlign="center"
          w="90px"
        >
          {jobProfile?.stats?.activeInsureds}
        </Text>
      </Box>
      <Box>
        <InputLabel labelName="Approved" toolTip={inAppText.tooltips.projectDetails.projectInformation.approved} />
        <Flex
          data-dusk-value={jobProfile?.stats?.approvalPercentage}
          dusk={JobProfilePage.approvalPercentage}
          justify="center"
          w="57px"
        >
          <ProgressCircle
            isArchived={isArchived}
            percentage={jobProfile?.stats?.approvalPercentage}
          />
        </Flex>
      </Box>
    </Flex>
  );
};

StatsFormLabel.propTypes = {
  label: PropTypes.string,
  textAlign: PropTypes.string
};

export default JobStats;
